import { render, staticRenderFns } from "./FileDelete.vue?vue&type=template&id=025835aa&scoped=true"
import script from "./FileDelete.vue?vue&type=script&lang=js"
export * from "./FileDelete.vue?vue&type=script&lang=js"
import style0 from "./FileDelete.vue?vue&type=style&index=0&id=025835aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025835aa",
  null
  
)

export default component.exports